<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theLogInstance' clearable @change="theLogInstanceChange" size="small" placeholder="选择方法">
          <el-option
              v-for="item in theLogInstanceAll"
              :key="item.name"
              :label="item.label+'-'+item.name"
              :value="item.name" >
          </el-option>
        </el-select>
        <el-input
          v-model="getSysMsgErrorGlobalList_data.smegUrl"
          placeholder="请输入请求接口"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getSysMsgErrorGlobalList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getSysMsgErrorGlobalList"
      :tableColums='tableColums_getSysMsgErrorGlobalList'
      api='getSysMsgErrorGlobalList::smegId'
      updateapi='updateSysMsgErrorGlobalStatus'
      :height="H-165" >
    </mytable> 

  </div>
</template>

<script>
export default {
  data() {
    return {
      theLogInstanceAll:[
        {name:"appcenter",label:"app和小程序"},
        {name:"opportunity",label:"后台管理"},
        {name:"receipt",label:"其他"},
        {name:"trainingmsg",label:"消息"},
      ],
      srelMethod:"",
      tableColums_getSysMsgErrorGlobalList: {
        $selection: false,

        smegUserName: ['用户名',100,],
        smegInstance: ['服务名',160,],
        smegUrl: ['请求接口',200,],
        smegParams: ['参数',200,],
        smegMsg: '错误信息',
        smegDes: '备注',
        createtime: ['创建时间',160,],
        smegStatus: ['状态',110,'@v-if: 1:未处理#danger, 2:已处理#success '],
        $operation: [
          '操作', 200,
          this.updateSysMsgErrorGlobalStatus && `@text: 编辑状态#success
           @v-if: $row.smegStatus == 1
           @click: _confirm('确定要更新已处理吗?')
                   .trigger('updateSysMsgErrorGlobalStatus',{smegId:$row.smegId})
                   .trigger('getSysMsgErrorGlobalList')
          `,
        ],
      },

    };
  },

  watch: {
    
  },

  methods: {
    theLogInstanceChange(id){
      this.srelMethod=id;
      this.getSysMsgErrorGlobalList({currentPage:1,smegInstance:this.srelMethod});
    },
  },

  created() {
    this.getSysMsgErrorGlobalList();
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/MsgErrorGlobal.vue